module.exports = __webpack_public_path__ + "static/media/businessman-2682712_1920.907b8ec6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/500/businessman-2682712_1920.jpg
// module id = 897
// module chunks = 0